/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import html2canvas from 'html2canvas';


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
const takeScreenShot = (url,width,height, cb, id, provider) => {

//creating element and appending it to the dom
    let img = document.createElement('IMG');
    img.src = url;
    let parent = document.createElement('DIV');
    parent.id=id;
    parent.style.cssText = 'height:0px; overflow:hidden';
    let element = document.createElement('DIV');
    element.style.cssText =  `overflow:hidden; height:${height}px; width:${width}px; `;
    element.appendChild(img);
    parent.appendChild(element);
    document.body.appendChild(parent);
    html2canvas(element,{allowTaint:false,useCORS:true,logging:false}).then(canvas => {
        canvas.toBlob(function (blob) {
            let url = URL.createObjectURL(blob);
            if(id && provider){
                cb(provider,id,url);
            }else{
                cb(url);
            }
        });
        //removing element from the dom
        if (!!parent) document.body.removeChild(parent);
        });
};
export default takeScreenShot;